import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-space-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_oss_data_table = _resolveComponent("oss-data-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_oss_data_table, {
      headers: _ctx.headers,
      items: _ctx.items,
      striped: true,
      loading: _ctx.loading
    }, {
      "no-data": _withCtx(() => [
        _createVNode(_component_v_row, {
          "no-gutters": "",
          class: "pa-2 d-flex align-center rounded-xl",
          style: {"background-color":"#fef8ee"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, {
              size: "small",
              icon: "$fa-bullseye"
            }),
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text-body-1 ml-4" }, "Pour tous les clients de mon cabinet", -1))
          ]),
          _: 1
        })
      ]),
      "item.type": _withCtx(({ item }) => [
        _createVNode(_component_v_icon, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.itemIcon(item.type)), 1)
          ]),
          _: 2
        }, 1024)
      ]),
      "item.actions": _withCtx(({ item }) => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_v_btn_trash, {
            onClick: ($event: any) => (_ctx.removeItem(item)),
            size: "small"
          }, null, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["headers", "items", "loading"])
  ]))
}